import React, { useState } from 'react';
import { Grid, TableCell } from '@mui/material';
import moment from 'moment';
import { TableWidgetV2 } from '../../../components/v2';
import DocumentoForm from './DocumentoForm';

const ArquivosTab = ({ values, setValues, readOnly }) => {
  const [open, setOpen] = useState(false);
  const [usuarioDocumento, setUsuarioDocumento] = useState(null);
  const [isCertificado, setIsCertificado] = useState(false);

  const renderRows = (s) => (
    <>
      <TableCell>{s.nome}</TableCell>
      <TableCell>{moment(s.dataDocumento).format('DD/MM/YYYY')}</TableCell>
      <TableCell>{s.validoAte ? moment(s.validoAte).format('DD/MM/YYYY') : '-'}</TableCell>
    </>
  );

  const getHeaderActions = (certificado) => {
    if (readOnly) return [];
    return [{
      title: 'Adicionar',
      onClick: () => {
        setIsCertificado(certificado);
        setOpen(true);
      },
    }];
  };

  const onSaveLocal = (documento) => {
    const existedDocumentos = values.documentos || [];
    setValues({
      ...values,
      documentos: [
        ...existedDocumentos.filter((d) => d.id !== documento.id),
        documento,
      ].sort((a, b) => a.nome.localeCompare(b.nome)),
    });
    setUsuarioDocumento(null);
  };

  const onEdit = (rowId) => {
    const doc = values.documentos.find((d) => d.id === rowId);
    setUsuarioDocumento(doc);
    setIsCertificado(doc.tipo === 'CERTIFICADO');
    setOpen(true);
  };

  const onDelete = (rowId) => {
    setValues({ ...values, documentos: values.documentos.filter((d) => d.id !== rowId) });
  };

  const getRows = (tipo) => (values.documentos || []).filter((d) => d.tipo === tipo);

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={getRows('DOCUMENTO')}
          titles={['Nome', 'Data Documento', 'Válido Até']}
          headerTitle="Documentos"
          hasAdd={false}
          renderRows={renderRows}
          extraHeaderActions={getHeaderActions(false)}
          hasRowActions
          showEdit={!readOnly}
          showView={readOnly}
          onEdit={onEdit}
          onView={onEdit}
          onDelete={onDelete}
          showDelete={!readOnly}
          emptyStateSize="compact"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={getRows('CERTIFICADO')}
          titles={['Nome', 'Data Documento', 'Válido Até']}
          headerTitle="Certificados"
          hasAdd={false}
          renderRows={renderRows}
          extraHeaderActions={getHeaderActions(true)}
          hasRowActions
          showEdit={!readOnly}
          showView={readOnly}
          onEdit={onEdit}
          onView={onEdit}
          onDelete={onDelete}
          showDelete={!readOnly}
          emptyStateSize="compact"
        />
      </Grid>
      <DocumentoForm
        open={open}
        usuarioDocumento={usuarioDocumento}
        onClose={() => {
          setOpen(false);
          setUsuarioDocumento(null);
        }}
        isCertificado={isCertificado}
        onSave={onSaveLocal}
        documentoUsuarioIds={(values.documentos || []).map((d) => d.id)}
        readOnly={readOnly}
      />
    </Grid>
  );
};

export default ArquivosTab;
